var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{ 'c-modal--open': _vm.show }},[_c('div',{staticClass:"c-modal__wrapper"},[_c('div',{staticClass:"c-modal__overlay",on:{"click":_vm.toggle}}),_vm._t("default",null,{"tabindex":"0"})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }